import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import { setBorderMixinAfter } from 'styles/mixins'

export const Tabbar = styled.div`
  position: relative;
  display: flex;
  background: ${COLORS.white};
  ${setBorderMixinAfter({
    borderRadius: '4px',
    extraPixels: 1
  })}
  border-radius: 4px;
  box-sizing: border-box;
`

export const ActiveTab = styled.div<{
  $activeTabIndex: number
  $isRTLDirection: boolean
  $tabWidth: number
  $height: number
}>`
  position: absolute;
  z-index: 1;
  height: ${props => props.$height}px;
  background: ${COLORS.primaryLight};
  border: 1px solid ${COLORS.primaryDark};
  border-radius: 4px;

  transform: ${props => {
    const sign = props.$isRTLDirection ? -1 : 1
    return (
      props.$activeTabIndex &&
      css`
        translateX(${sign * (props.$tabWidth * props.$activeTabIndex + 1)}px);
  `
    )
  }};
  width: ${props => `${props.$tabWidth + 1}px`};
  box-shadow: 0px 0px 4px 0px ${COLORS.borderColor};
  transition: all 0.2s ease-in 0s;
`

export const FlatTabbarWrapper = styled.div<{
  $withoutPadding: boolean
  $isTabbarVisible: boolean
  $height: number
}>`
  width: 100%;
  height: ${props => props.$height}px;
  opacity: ${props => (props.$isTabbarVisible ? '1' : '0')};
`
